<template>
  <q-page padding>
    <div>
      <q-btn
        label="atualizacao-estoque"
        color="positive"
        no-caps
        icon="done"
        @click="estoque"
      />

      <q-btn
        label="sync-produtos"
        class="q-ml-sm"
        color="negative"
        no-caps
        icon="close"
        @click="produtos"
      />
    </div>
  </q-page>
</template>

<script>
import { useStore } from "vuex";

export default {
  setup() {
    const store = useStore();

    const estoque = async () => {
      await store.dispatch("integracao/estoque");
    };

    const produtos = async () => {
      await store.dispatch("integracao/produtos");
    };

    return {
      estoque,
      produtos,
    };
  },
};
</script>

<style></style>
